<template>
  <main-content>
    <b-card>
      <ERegistrationHeaderFormInfo />
      <ERegistrationProfessionalUpgradeForm :info="info" :loginInfo="loginInfo" :businessId="businessId"/>
    </b-card>
  </main-content>
</template>

<script>
import ERegistrationProfessionalUpgradeForm from "../components/e-registration-professional-upgrade/ERegistrationProfessionalUpgradeForm";
import ERegistrationHeaderFormInfo from "../components/e-registration-header-form/ERegistrationHeaderFormInfo"

export default {
  props: ["info", "businessId", "loginInfo"],
  components: {
    ERegistrationHeaderFormInfo,
    ERegistrationProfessionalUpgradeForm
  },
  beforeRouteEnter(to, from, next) {
    if (!to.params.info) {
      next({ name: "ERegistrationProfessionalActivate" });
    } else {
      next();
    }
  }
};
</script>

<style lang="scss" scoped></style>
